import Vue from "vue";
import VueRouter from "vue-router";
import Login from "./views/Login.vue";
import store from "./store";

Vue.use(VueRouter);

store.dispatch("autologin");

export default new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "login",
      component: Login
    },
    {
      path: "/home",
      name: "home",
      // route level code-splitting
      // this generates a separate chunk (home.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "home" */ "./views/Home.vue")
    }
  ]
});
